<template>
  <el-dialog
    :title="$t('text.calibration_data')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="620px"
    @close="closeDialog()"
  >
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-row class="mb-20" v-if="form.id">
          <el-col :span="24">
            <span class="mr-20">{{ $t('text.pod') }}: {{ form.podId }}</span>
            <!-- <span class="mr-20"
                >{{ $t('text.capacitive') }} Cal: {{ form.capactive_cal }}</span
              >
              <span
                >{{ $t('text.accelerometer') }} Cal:
                {{ form.accelerometer_cal }}</span
              > -->
          </el-col>
        </el-row>
        <el-form-item :label="$t('text.pod')" prop="podId" v-else>
          <el-input v-model="form.podId"></el-input>
        </el-form-item>
        <div class="cal-section-title">{{ $t('text.capacitive_sensor') }}</div>
        <el-row>
          <el-col :sm="12" :xs="24">
            <el-form-item label="S1_Offset" prop="sensor1_offset">
              <el-input-number
                v-model="form.sensor1_offset"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="S2_Offset" prop="sensor2_offset">
              <el-input-number
                v-model="form.sensor2_offset"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="S1_Gain" prop="sensor1_gain">
              <el-input-number
                v-model="form.sensor1_gain"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="S2_Gain" prop="sensor2_gain">
              <el-input-number
                v-model="form.sensor2_gain"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <div class="cal-section-title">{{ $t('text.battery') }}</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <div class="cal-section-title">{{ $t('text.thermistor') }}</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Bat_Offset" prop="battery_offset">
              <el-input-number
                v-model="form.battery_offset"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Temp_Offset" prop="temperature_offset">
              <el-input-number
                v-model="form.temperature_offset"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="cal-section-title">{{ $t('text.accelerometer') }}</div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Acc_XOffset" prop="accelerometer_xoffset">
              <el-input-number
                v-model="form.accelerometer_xoffset"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Acc_XGain" prop="accelerometer_xgain">
              <el-input-number
                v-model="form.accelerometer_xgain"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Acc_YOffset" prop="accelerometer_yoffset">
              <el-input-number
                v-model="form.accelerometer_yoffset"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Acc_YGain" prop="accelerometer_ygain">
              <el-input-number
                v-model="form.accelerometer_ygain"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Acc_ZOffset" prop="accelerometer_zoffset">
              <el-input-number
                v-model="form.accelerometer_zoffset"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Acc_ZGain" prop="accelerometer_zgain">
              <el-input-number
                v-model="form.accelerometer_zgain"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="cal-section-title">
              {{ $t('text.other') | firstLetterCapitalize }}
            </div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Firmware Ver" prop="fwVersion">
              <el-input v-model="form.fwVersion"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Hardware Ver" prop="hwVersion">
              <el-input v-model="form.hwVersion"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()" :loading="loading">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        id: 0,
        podId: '',
        capactive_cal: '',
        accelerometer_cal: '',
        sensor1_offset: '',
        sensor2_offset: '',
        sensor1_gain: '',
        sensor2_gain: '',
        battery_offset: '',
        temperature_offset: '',
        accelerometer_xoffset: '',
        accelerometer_xgain: '',
        accelerometer_yoffset: '',
        accelerometer_ygain: '',
        accelerometer_zoffset: '',
        accelerometer_zgain: '',
        fwVersion: '',
        hwVersion: ''
      },
      rules: this.initRules()
    }
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.rules = this.initRules()
    }
  },
  methods: {
    initRules() {
      return {
        sensor1_offset: [
          {
            required: true,
            message: this.$t('text.s1_offset_required')
          }
        ],
        sensor2_offset: [
          {
            required: true,
            message: this.$t('text.s2_offset_required')
          }
        ],
        sensor1_gain: [
          {
            required: true,
            message: this.$t('text.s1_gain_required')
          }
        ],
        sensor2_gain: [
          {
            required: true,
            message: this.$t('text.s2_gain_required')
          }
        ],
        battery_offset: [
          {
            required: true,
            message: this.$t('text.bat_offset_required')
          }
        ],
        temperature_offset: [
          {
            required: true,
            message: this.$t('text.temp_offset_required')
          }
        ],
        accelerometer_xoffset: [
          {
            required: true,
            message: this.$t('text.acc_x_offset_required')
          }
        ],
        accelerometer_xgain: [
          {
            required: true,
            message: this.$t('text.acc_x_gain_required')
          }
        ],
        accelerometer_yoffset: [
          {
            required: true,
            message: this.$t('text.acc_y_offset_required')
          }
        ],
        accelerometer_ygain: [
          {
            required: true,
            message: this.$t('text.acc_y_gain_required')
          }
        ],
        accelerometer_zoffset: [
          {
            required: true,
            message: this.$t('text.acc_z_offset_required')
          }
        ],
        accelerometer_zgain: [
          {
            required: true,
            message: this.$t('text.acc_z_gain_required')
          }
        ],
        fwVersion: [
          {
            required: true,
            message: this.$t('text.firmware_version_required')
          }
        ],
        hwVersion: [
          {
            required: true,
            message: this.$t('text.hardware_version_required')
          }
        ],
        podId: [
          {
            required: true,
            message: this.$t('text.pod_id_required')
          }
        ]
      }
    },
    openDialog() {
      this.dialogVisible = true
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    getParams() {
      return {
        ID: this.form.id,
        PodId: this.form.podId,
        Accelerometer_xgain: this.form.accelerometer_xgain,
        Accelerometer_xoffset: this.form.accelerometer_xoffset,
        Accelerometer_ygain: this.form.accelerometer_ygain,
        Accelerometer_yoffset: this.form.accelerometer_yoffset,
        Accelerometer_zgain: this.form.accelerometer_zgain,
        Accelerometer_zoffset: this.form.accelerometer_zoffset,
        Battery_offset: this.form.battery_offset,
        FWVersion: this.form.fwVersion,
        HWVersion: this.form.hwVersion,
        Sensor1_gain: this.form.sensor1_gain,
        Sensor1_offset: this.form.sensor1_offset,
        Sensor2_gain: this.form.sensor2_gain,
        Sensor2_offset: this.form.sensor2_offset,
        Temperature_offset: this.form.temperature_offset
      }
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.AddorUpdatePodCharacteristics(this.getParams())
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.$parent.getData()
                this.closeDialog()
              } else {
                swal({
                  icon: 'error',
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    },
    resetForm() {
      this.form = {
        id: 0,
        podId: '',
        capactive_cal: '',
        accelerometer_cal: '',
        sensor1_offset: '',
        sensor2_offset: '',
        sensor1_gain: '',
        sensor2_gain: '',
        battery_offset: '',
        temperature_offset: '',
        accelerometer_xoffset: '',
        accelerometer_xgain: '',
        accelerometer_yoffset: '',
        accelerometer_ygain: '',
        accelerometer_zoffset: '',
        accelerometer_zgain: '',
        fwVersion: '',
        hwVersion: ''
      }
      this.$refs['form'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.cal-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 8px;
  margin: 20px 0 8px;
}
</style>
